export const documentStatusOptions = [
  { id: "draft", title: "Draft" },
  { id: "active", title: "Active" },
  { id: "archived", title: "Archived" },
];
